import { useMutation } from "@tanstack/react-query";
import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap";
import ComplianceMonitoringService from "src/modules/3rd-party-management/apis/admin/compliance/monitoring/MonitoringService";

const StopMonitoringModal = ({ 
    t, 
    person, 
    isOpen, 
    toggle, 
    onCompleted 
}) => {
    const name = person?.fullName || t("this person");
    const handleStopMonitoring = useMutation({
        mutationFn: async (payload) => {
            const service = ComplianceMonitoringService.getInstance();

            return await service.removePersonFromMonitoringList(person?.id, payload);
        },
        onSuccess: () => {
            toast(
                t("Monitoring stopped successfully for the selected person."),
                {
                    type: 'success'
                }
            );

            onCompleted && onCompleted();
        },
        onError: () => {
            toast(
                t("Failed to stop monitoring. Please try again or check the selected item."),
                {
                    type: 'error'
                }
            );
        },
        onSettled: () => {
            toggle();
        }
    });

    return (
        <Modal 
            isOpen={isOpen} 
            toggle={toggle} 
            centered
        >
            <ModalHeader toggle={toggle}>
                {t('Stop Monitoring')}
            </ModalHeader>

            <ModalBody>
                {t('Are you sure you want to stop monitoring for {{name}}', { name: '' })}
                <strong>{name}</strong>?
                <br />
                <br />
                {t('This will stop tracking future changes and alerts for this entity.')}
            </ModalBody>

            <ModalFooter>
                <Button 
                    color="secondary" 
                    onClick={toggle}
                >
                    {t('Cancel')}
                </Button>

                <Button
                    color="warning"
                    disabled={handleStopMonitoring.isLoading}
                    onClick={() => {
                        handleStopMonitoring.mutate();
                    }}
                >
                    {handleStopMonitoring.isLoading && (
                        <Spinner 
                            size="sm" 
                            color="light" 
                            className="me-2" 
                        />
                    )}
                    
                    {t('Stop Monitoring')}
                </Button>
            </ModalFooter>

        </Modal>
    );
};

export default withNamespaces()(
    StopMonitoringModal
);